// extracted by mini-css-extract-plugin
export var skipAnimation = "_46-0";